import { useEffect } from 'react';
import { useState } from 'react';
import { FormHelperText, Grid, InputLabel, Typography } from '@material-ui/core';
import { SecondaryButton, TextBox } from '../../../../../../Core/FormInput';
import { postJobProgressInWorkshop } from '../../../../../../Core/Service/communicator-service';
import { useContext } from 'react';
import AppContext from '../../../../../../App/AppContext';
import { singleEmailValidation } from '../../../../../../Core/Service/StaticService';
import formatters from '../../../../../../Core/Grid/inputFormatter';

const InWorkShopModal = (props) => {
    const { showToast } = useContext(AppContext);

    const [state, setState] = useState({
        messaegList: [],
        actionLog: false,
        editActionLog: false,
        selectedStatus: props.selectedStatus,
        logText: '',
        workInProgress: formatters.DateTimeTHMSFormatter(props.stepperData?.workInProgress || new Date()),
        errors: {}
    });

    useEffect(() => {
        let obj = props.statusList || {};
        setState((st) => ({
            ...st,
            isCustomerUpdate: obj?.sendEmail,
            isUpdateSms: obj?.sendSMSUpdate,
            isCustomerEmail: obj?.email,
            isPhoneNo: obj?.phone,
            logText: obj?.smsText,
            isPhoneVisible: obj?.sendSMSUpdate,
            isEmailVisible: obj?.sendEmail,
            noDataVisible: !obj.sendSMSUpdate && !obj.sendEmail
        }));
    }, [props.statusList]);

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        if (type == 'checkbox') {
            setState((st) => {
                let newSt = { ...st };
                newSt[name] = checked;
                if (!newSt.isCustomerUpdate) {
                    newSt.isCustomerEmail = '';
                }
                if (!newSt.isUpdateSms) {
                    newSt.isPhoneNo = '';
                }
                return newSt;
            });
        } else {
            setState((st) => ({ ...st, [name]: value }));
        }
    };

    const validation = () => {
        let { partStatus, workInProgress, isCustomerUpdate, isCustomerEmail, isUpdateSms, isPhoneNo } = state;
        let isValid = true;
        let errors = {};

        if (!workInProgress) {
            isValid = false;
            errors.workInProgress = 'Please Add Checked Out Date';
        }
        if (isCustomerUpdate && !singleEmailValidation(isCustomerEmail)) {
            isValid = false;
            errors.isCustomerEmail = 'Please Add Customer Email';
        }
        if (isUpdateSms && !isPhoneNo) {
            isValid = false;
            errors.isPhoneNo = 'Please Add Customer Email';
        }

        setState((st) => ({ ...st, errors: errors }));
        return isValid;
    };

    const handleSubmit = async () => {
        if (validation()) {
            let data = {
                // headerRecordID: props.headerRecordID,
                tCardID: props.tCardID,
                workInProgress: state.workInProgress,
                status: +state.selectedStatus,
                logText: state.logText,
                isPhoneNo: state.isPhoneNo,
                isCustomerEmail: state.isCustomerEmail
            };
            let res = await postJobProgressInWorkshop(data);
            if (res.success) {
                showToast(`Checked Out Status Added Successfully`);
                props.onClose(true);
            } else {
                showToast(`Checked Out Status Failed To Add`);
            }
        }
    };

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <InputLabel shrink required className="mandatoryfields">
                        Workshop Date Time
                    </InputLabel>
                    <TextBox type="datetime-local" name="workInProgress" value={state.workInProgress} variant="outlined" fullWidth onChange={handleInput} />
                    <FormHelperText error>{state.errors.workInProgress}</FormHelperText>
                </Grid>
                {(state.isPhoneVisible || state.isEmailVisible) && (
                    <Grid item xs={12}>
                        <Typography color="secondary">Customer Message</Typography>
                        <TextBox
                            placeholder="Message"
                            rows={3}
                            multiline
                            type="text"
                            name="logText"
                            variant="outlined"
                            fullWidth
                            value={state.logText}
                            onChange={handleInput}
                        />
                        <FormHelperText error>{state.errors.logText}</FormHelperText>
                    </Grid>
                )}
                {state.isEmailVisible && (
                    <Grid item xs={12} md={8}>
                        <InputLabel shrink>
                            <input
                                type="checkbox"
                                style={{ cursor: 'pointer' }}
                                name="isCustomerUpdate"
                                onChange={handleInput}
                                checked={state.isCustomerUpdate}
                            />
                            Customer Email
                        </InputLabel>
                        <TextBox
                            placeholder="Email update to customer"
                            type="email"
                            name="isCustomerEmail"
                            variant="outlined"
                            fullWidth
                            value={state.isCustomerEmail}
                            onChange={handleInput}
                            error={state.isCustomerUpdate}
                        />
                        <FormHelperText error>{state.errors.isCustomerEmail}</FormHelperText>
                    </Grid>
                )}
                {state.isPhoneVisible && (
                    <Grid item xs={12} md={4}>
                        <InputLabel shrink>
                            <input type="checkbox" style={{ cursor: 'pointer' }} onChange={handleInput} name="isUpdateSms" checked={state.isUpdateSms} />
                            Phone Number
                        </InputLabel>
                        <TextBox
                            placeholder="Phone Number"
                            type="tel"
                            name="isPhoneNo"
                            variant="outlined"
                            fullWidth
                            value={state.isPhoneNo}
                            onChange={handleInput}
                            error={state.isUpdateSms}
                        />
                        <FormHelperText error>{state.errors.isPhoneNo}</FormHelperText>
                    </Grid>
                )}
                <Grid item xs={12}>
                    <SecondaryButton className="Submitbtn" fullWidth onClick={handleSubmit}>
                        Set Work In Progress
                    </SecondaryButton>
                </Grid>
            </Grid>
        </div>
    );
};

export default InWorkShopModal;
